import * as React from 'react'
function SvgPaymentFlexible(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g fill="none" fillRule="evenodd">
				<path
					d="M14 4v4h12V4h4v4h4a2 2 0 012 2v24a2 2 0 01-2 2H6a2 2 0 01-2-2V10a2 2 0 012-2h4V4h4zm18 10H8v18h24V14zm-11 4l7 5-7 5v-3h-9v-4h9v-3z"
					fill="currentColor"
				/>
			</g>
		</svg>
	)
}
export default SvgPaymentFlexible
